function sanitizeAccountDefaultRecipient(accountDefaultRecipient) {
  if (typeof accountDefaultRecipient === 'string') {
    const trimmed = accountDefaultRecipient.trim();

    return trimmed !== '' && trimmed;
  }

  return false;
}

export function channel(account) {
  // Grab account from profile or logged in user
  const profile = (window['__session__'] || {}).profile || account || {};

  return {
    name: profile.subdomain_name ? profile.subdomain_name : false,
    defaultRecipient: sanitizeAccountDefaultRecipient(
      profile.default_recipient_email
    ),
    defaultRecipientVerified: profile.receiving_email_confirmed,
    profileReceivingLocked: profile.profile_receiving_locked,
  };
}

export default channel();
